
import { AssetPreviewApprovalButtonsController } from './asset-preview-approval-buttons.controller'

function assetPreviewApprovalButtons () {
  return {
    restrict: 'E',
    scope: {
      template: '<',
      location: '<',
      internalApproval: '<',
      previewFlags: '='
    },
    templateUrl: '/core/directives/asset-preview-approval-buttons/asset-preview-approval-buttons.html?$$REVISION$$',
    controller: AssetPreviewApprovalButtonsController
  }
}
export { assetPreviewApprovalButtons }
